import isNil from 'lodash/isNil';
import { parse } from 'query-string';

export function getUsePassportAccountsFromSearchString(): boolean {
    const windowSearch = !isSSR ? window.location.search : null;

    if (!windowSearch) {
        return false;
    }

    const usePassportAccounts = parse(windowSearch).usePassportAccounts;

    return !isNil(usePassportAccounts) ? usePassportAccounts === 'true' : false;
}
